export const projectsData = [{
        "id": 1,
        "name": "Readmos",
        "autors": ["arre[code]"],
        "description": "Show the README.md of any Github repository in your web.",
        "image": require("./images/readmos.png").default,
        "technologies": ["Javascript", "Github REST API", "HTML", "CSS", "Bootstrap 5"],
        "github_readmos": "https://github.com/axelromero99/readmos",
    },
    {
        "id": 2,
        "name": "arre[code]",
        "autors": ["arre[code]"],
        "description": "Web Portfolio",
        "image": require("./images/arrecode.png").default,
        "technologies": ["Javascript", "Github REST API", "HTML", "CSS", "Bootstrap 5"],
        "github_readmos": "https://github.com/axelromero99/readmos",
    }

]